import React from 'react';
import './Common.css';

const LoadingSpinner = ({ text = 'Loading...' }) => {
    return (
        <div className="loading-spinner">
            <div className="spinner"></div>
            {text && <div className="spinner-text">{text}</div>}
        </div>
    );
};

export default LoadingSpinner;
